import { render, staticRenderFns } from "./PersonnelRecordDetailsTabOther.vue?vue&type=template&id=165e1fb6"
import script from "./PersonnelRecordDetailsTabOther.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports